import {AbstractControl, FormGroup, ValidationErrors, ValidatorFn} from '@angular/forms';

export function sixDigitNumberValidator(): ValidatorFn {
  return (control: AbstractControl): {[key: string]: unknown} | null => {
    const value = control.value;
    // Ensure the value is a number, not a string representation of a number, and in the 6-digit range.
    const isValid = !isNaN(value) && value >= 100000 && value <= 999999;
    return isValid ? null : {sixDigitNumber: {value: control.value}};
  };
}

export const passwordMatchValidator: ValidatorFn = (formGroup: FormGroup): ValidationErrors | null => {
  const password = formGroup.get('password')?.value;
  const confirmPassword = formGroup.get('confirmPassword')?.value;
  if (password && password !== confirmPassword) {
    return {passwordMismatch: true};
  }
  return null;
};
